import { styled } from '@mui/material/styles';
import { DialogTitle, DialogActions } from '@mui/material';
import ButtonBase from '../../../../components/Button';

export const StyledDialogTitle = styled(DialogTitle)({
  display: 'flex',
  justifyContent: 'center',
});

export const StyledDialogActions = styled(DialogActions)({
  display: 'flex',
  justifyContent: 'center',
});

export const IconImage = styled('img')({
  width: '80px',
});

export const Description = styled('span')({
  fontSize: '22px',
});

export const StyledButton = styled(ButtonBase)(({ theme }) => ({
  borderRadius: 0,
  padding: '10px 30px',
  backgroundColor: theme.palette.primary.dark,
  color: '#fff',
  width: '200px',
  textTransform: 'capitalize',
  [theme.breakpoints.up('sm')]: {
    fontSize: '15px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));
